import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";

const DuplicateCheck = ({ matchType }) => {
    if (matchType === 3) {
        return null;
    }

    return (
        <div className="duplicate-check">
            <button
                className="button -no-pointer"
                disabled={true}
            >
                <div className="bubble">{"✓"}</div>
                <FontAwesomeIcon icon={faClone} />
            </button>
        </div>
    );
};

export default DuplicateCheck;
